import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const articles = [
  {
    id: 1,
    title: '史上最全马卡龙制作指南',
    summary: '从基础材料选择到制作技巧，详细讲解如何制作完美马卡龙',
    category: '教程',
    date: '2024-03-15',
    readTime: '8分钟',
    image: 'article-1.jpg',
  },
  {
    id: 2,
    title: '如何选择适合自己的烤箱',
    summary: '详细分析家用烤箱的选购要点，帮助烘焙新手选对第一台烤箱',
    category: '工具',
    date: '2024-03-10',
    readTime: '6分钟',
    image: 'article-2.jpg',
  },
  {
    id: 3,
    title: '天然酵母 vs 商业酵母',
    summary: '深度解析两种酵母的优缺点，以及何时该选择哪种酵母',
    category: '知识',
    date: '2024-03-05',
    readTime: '10分钟',
    image: 'article-3.jpg',
  },
  {
    id: 4,
    title: '奶油霜调色技巧大全',
    summary: '韩式裱花必学的奶油霜调色技巧，让你轻松调出高级感配色',
    category: '技巧',
    date: '2024-02-28',
    readTime: '7分钟',
    image: 'article-4.jpg',
  },
  {
    id: 5,
    title: '法式面包的发酵奥秘',
    summary: '揭秘法式面包制作的发酵工艺，如何判断发酵状态',
    category: '教程',
    date: '2024-02-20',
    readTime: '9分钟',
    image: 'bread.jpg',
  },
  {
    id: 6,
    title: '烘焙失败案例分析',
    summary: '常见烘焙失败原因解析，帮你避免这些坑',
    category: '经验',
    date: '2024-02-15',
    readTime: '5分钟',
    image: 'article-2.jpg',
  },
]

const categories = ['全部', '教程', '技巧', '知识', '经验']

export default function Articles() {
  return (
    <div className="grain-overlay">
      {/* Hero */}
      <section className="relative py-20 bg-gradient-to-br from-cream via-cream to-champagne/10">
        <div className="absolute top-10 right-20 w-64 h-64 bg-champagne/20 rounded-full blur-3xl" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <h1 className="font-display text-5xl text-chocolate mb-6">教学文章</h1>
            <p className="text-lg text-chocolate/60 max-w-2xl mx-auto">
              分享烘焙知识与心得，助您烘焙之路更顺畅
            </p>
          </motion.div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((cat, index) => (
              <button
                key={cat}
                className={`px-6 py-2 rounded-full font-medium transition-all ${
                  index === 0
                    ? 'bg-caramel text-white'
                    : 'bg-cream text-chocolate hover:bg-caramel/20'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Articles Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((article, index) => (
              <motion.article
                key={article.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-cream rounded-2xl overflow-hidden shadow-lg card-hover group cursor-pointer"
              >
                <div className="aspect-video overflow-hidden">
                  <img src={`/images/${article.image}`} alt={article.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="px-3 py-1 bg-caramel/10 text-caramel text-sm rounded-full">
                      {article.category}
                    </span>
                    <span className="text-sm text-chocolate/60">{article.date}</span>
                  </div>
                  <h2 className="font-display text-xl text-chocolate mb-3 group-hover:text-caramel transition-colors">
                    {article.title}
                  </h2>
                  <p className="text-chocolate/60 text-sm mb-4 line-clamp-2">{article.summary}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-chocolate/60">阅读时长: {article.readTime}</span>
                    <span className="text-caramel font-medium group-hover:text-champagne transition-colors">
                      阅读全文 →
                    </span>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex justify-center gap-2 mt-12">
            <button className="w-10 h-10 rounded-full bg-caramel text-white font-medium">1</button>
            <button className="w-10 h-10 rounded-full bg-cream text-chocolate hover:bg-caramel/20 font-medium">2</button>
            <button className="w-10 h-10 rounded-full bg-cream text-chocolate hover:bg-caramel/20 font-medium">3</button>
            <button className="w-10 h-10 rounded-full bg-cream text-chocolate hover:bg-caramel/20 font-medium">→</button>
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-16 bg-gradient-to-r from-chocolate to-caramel-dark">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display text-3xl text-white mb-4">订阅烘焙技巧 newsletter</h2>
          <p className="text-white/70 mb-8">
            每周获取最新烘焙教程和实用技巧
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
            <input
              type="email"
              placeholder="输入您的邮箱"
              className="flex-1 px-6 py-3 rounded-lg text-chocolate focus:outline-none focus:ring-2 focus:ring-champagne"
            />
            <button className="px-8 py-3 bg-champagne text-chocolate rounded-lg font-semibold hover:bg-cream transition-colors">
              订阅
            </button>
          </div>
        </div>
      </section>
    </div>
  )
}